import NotificationBell from "./home/notification";
import GlobalSearch from "./GlobalSearch";
import CallSheetChip from "./call-sheet/CallSheetChip";
import { useStateValue } from "../context/StateProvider";

export default function PageHeader({ title, subtitle, actions, children }) {
  const [{ user }] = useStateValue();

  return (
    <header className="sticky top-0 z-40 flex items-center justify-between gap-3 lg:gap-4 pl-16 pr-3 lg:px-8 py-3 bg-white border-b border-slate-200 min-h-[64px]">
      <div className="flex-1 min-w-0">
        {title && (
          <h1 className="text-xl font-bold text-slate-900 truncate">{title}</h1>
        )}
        {subtitle && (
          <p className="hidden sm:block text-xs text-slate-500 mt-0.5 truncate">{subtitle}</p>
        )}
        {children}
      </div>
      <div className="flex items-center gap-2 lg:gap-3 flex-shrink-0">
        <CallSheetChip />
        {actions}
        {user && <GlobalSearch />}
        {user && <NotificationBell />}
      </div>
    </header>
  );
}
